import { useState } from 'react';
import { Box } from '@mui/material';
import Link from 'next/link';
import { useForm } from 'react-hook-form';
import { parseCookies } from 'nookies';
import ActionButton from '@components/ActionButton';
import FormBaseLayout from '@components/FormBaseLayout';
import { useAuthentication } from '@source/contexts/AuthenticationContext';
import { useToast } from '@source/recoil/useToast/hook';
import { VerificationWarningBox } from '../VerificationWarningBox';
import * as S from './styles';

const SignInForm: React.FC = (): JSX.Element => {
  const { handleToast } = useToast();
  const [loadingLoginEmail, setLoadingLoginEmail] = useState(false);
  const [wrongCredentials, setWrongCredentials] = useState(false);

  const cookies = parseCookies();
  const redirect = cookies['riderize@redirect'];

  const { signIn, setRedirectUrl } = useAuthentication();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = async data => {
    try {
      setLoadingLoginEmail(true);
      setWrongCredentials(false);

      if (redirect) {
        setRedirectUrl(redirect);
      }

      await signIn(data);
      setLoadingLoginEmail(false);

      window.location.href = redirect || '/';
    } catch (error: unknown) {
      setWrongCredentials(true);
      handleToast('error', 'E-mail ou senha inválidos');
      setLoadingLoginEmail(false);
    }
  };

  return (
    <FormBaseLayout>
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{
          width: '100%'
        }}
      >
        {wrongCredentials && (
          <VerificationWarningBox
            errorTitle="credentials"
            messageTitle="credentials"
            setCodeIsWrong={setWrongCredentials}
          />
        )}

        <S.Input
          width="100%"
          type="email"
          placeholder="E-mail"
          {...register('email', { required: true })}
        />
        {errors.email && errors.email.type === 'required' && (
          <S.ErrorMessage>E-mail obrigatório</S.ErrorMessage>
        )}

        <S.Input
          width="100%"
          type="password"
          placeholder="Senha"
          {...register('password', { required: true, minLength: 6 })}
        />
        {errors.password && errors.password.type === 'required' && (
          <S.ErrorMessage>Senha obrigatória</S.ErrorMessage>
        )}
        {errors.password && errors.password.type === 'minLength' && (
          <S.ErrorMessage>Senha muito curta</S.ErrorMessage>
        )}

        <Box sx={{ width: '100%', textAlign: 'right', margin: '1.6rem 0' }}>
          <Link legacyBehavior href="/forgotPassword" passHref>
            <a>Esqueceu sua senha?</a>
          </Link>
        </Box>

        <ActionButton
          loading={loadingLoginEmail}
          type="submit"
          label="Entrar"
          labelcolor="yellow"
          width="100%"
          onClick={() => setWrongCredentials(false)}
        />
      </form>
    </FormBaseLayout>
  );
};

export default SignInForm;
